import { useMemo } from 'react';
import { useCurrentSoftwareNumber } from '../../store/software-number';
import { useMembership } from './users';
import { PAGE_SIZE } from './constants';
import { useTranslation } from '@ifit/rapport-webview';

const useDefaultTrimOptions = () => ({
  trim: ['lastCompleted', 'estimates'],
});

export const challengeStoreFF =
  'featureflag://flag?key=challenge-store&type=bool';

export const useRequiredRequestOptions = () => {
  const softwareNumber = useCurrentSoftwareNumber();
  const { membershipType } = useMembership();
  const { locale } = useTranslation();
  const useGatewayCache = Boolean(window?.NODE_ENV === 'production');
  const { trim } = useDefaultTrimOptions();
  return useMemo(
    () => ({
      softwareNumber,
      membershipType,
      useGatewayCache,
      headers: { 'Accept-Language': locale },
      trim,
    }),
    [softwareNumber, membershipType, locale, useGatewayCache, trim],
  );
};
export const useInfiniteQueryOptions = () => useRequiredRequestOptions();
export const useRowQueryOptions = () => {
  const requiredOptions = useRequiredRequestOptions();
  const perPage = 10;

  return useMemo(() => ({ perPage, ...requiredOptions }), [
    requiredOptions,
    perPage,
  ]);
};

export const useBasicAuthOptions = () => ({
  useBasicAuth: true,
});
export const useBasicAuthWithCacheOptions = () => ({
  ...useBasicAuthOptions(),
  useGatewayCache: true,
});

export const useQueryOptionsWithRowParams = () => {
  const requiredOptions = useRequiredRequestOptions();
  return {
    perPage: PAGE_SIZE,
    sortBy: undefined,
    overrides: undefined,
    ...requiredOptions,
  };
};

export const useMembershipTypeDisabler = () => ({
  enabled: useMembership().membershipType !== undefined,
});
